import { useInfiniteQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { getNotifications } from "../../../api/services/notifications";

export const useNotifications = () => {
  const { i18n } = useTranslation();

  return useInfiniteQuery({
    queryKey: ["Notifications", i18n.language],
    queryFn: ({ pageParam = 0 }) => getNotifications(pageParam),
    initialPageParam: 0,
    staleTime: 5 * 60 * 1000,
    getNextPageParam: (lastPage, allPages) => {
      const totalPages = Math.ceil(lastPage.data.total / 10);
      const nextPage = allPages.length;
      return nextPage < totalPages ? nextPage : undefined;
    },
  });
};
